var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.courseData)?_c('course-card',_vm._b({},'course-card',_vm.courseData,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }